<template>
  <ul
    v-if="props.selectOptions && props.selectOptions.length > 0"
    class="autocomplete-dropdown"
  >
    <li
      v-for="option in props.selectOptions"
      :key="option.key"
      class="autocomplete-option"
      @click="optionSelected(option)"
    >
      {{ option.text }}
    </li>
  </ul>
</template>

<script setup lang="ts">

interface Props {
  selectOptions?: { key: string; text: string }[];
}

const props = withDefaults(defineProps<Props>(), {
  selectOptions: () => [],
});

const emit = defineEmits<{
  (e: "optionSelected", value: { key: string; text: string }): void;
}>();

const optionSelected = (option: { key: string; text: string }) => {
  emit("optionSelected", option);
};
</script>

<style scoped>
.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  max-height: 220px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.autocomplete-option {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 16px;
  color: #222;
  transition: background 0.2s;
}
.autocomplete-option:hover {
  background: #f2f2f2;
}
</style>
